import { create } from 'zustand';

// État d'UI « sélection multiple » des candidats (cases à cocher de la liste admin).
// C'est de l'état client pur : il ne vient pas du serveur, donc il vit dans un store
// zustand plutôt que dans la couche TanStack Query. Remplace l'ancien morceau Redux
// `state.candidates.selectedCandidatesIds` + les actions UpdateSelectedCandidates /
// DeleteSelectedCandidates (réinitialisation de la sélection après suppression).
interface CandidatesSelectionState {
    selectedCandidatesIds: string[];
    // Remplace dispatch(UpdateSelectedCandidates(ids)).
    setSelectedCandidates: (ids: string[]) => void;
    // Bascule un id dans/hors de la sélection (logique de la checkbox de la liste).
    toggleCandidateSelection: (id: string) => void;
    // Vide la sélection (équivalent du reset opéré par DeleteSelectedCandidates).
    clearSelectedCandidates: () => void;
}

export const useCandidatesSelectionStore = create<CandidatesSelectionState>((set) => ({
    selectedCandidatesIds: [],
    setSelectedCandidates: (ids) => set({ selectedCandidatesIds: ids }),
    toggleCandidateSelection: (id) =>
        set((state) => ({
            selectedCandidatesIds: state.selectedCandidatesIds.includes(id)
                ? state.selectedCandidatesIds.filter((selectedId) => selectedId !== id)
                : [...state.selectedCandidatesIds, id],
        })),
    clearSelectedCandidates: () => set({ selectedCandidatesIds: [] }),
}));
